<template>
  <div v-if="loading">
    <div style="justify-content: center; height: 50px">
      <vue-simple-spinner
        size="medium"
        line-fg-color="rgb(255, 0, 0)"
        style="margin-top: 15px"
      />
    </div>
  </div>
  <div v-else style="user-select: none">
    <wg-modal
      v-if="isDropModalOpen"
      :width="windowWidth > 700 ? '500px' : '80%'"
      :portal="true"
      @closeModal="deleteDrop"
    >
      <div slot="header" class="com-anm22-app-text-xl">
        <span>{{
          $anm22.strLang(lang, "Edit project", "Modifica progetto")
        }}</span>
      </div>
      <div slot="body">
        <div>
          {{
            $anm22.strLang(
              lang,
              "Confirm the project new date.",
              "Confermare la nuova data di consegna?",
            )
          }}
        </div>
        <div class="vertical-height-div" style="height: 10px"></div>
        <div>
          {{ $anm22.strLang(lang, "Project:", "Progetto:") }}
          {{ dragEvent.name }}
        </div>
        <div>
          {{ $anm22.strLang(lang, "New deadline", "Nuova data:") }}
          {{ dropNewDate.format("Y-MM-DD") }}
        </div>
        <div class="vertical-height-div" style="height: 20px"></div>
        <div class="wg-row">
          <input
            type="button"
            :value="$anm22.strLang(lang, 'Confirm', 'Conferma')"
            @click="confirmDrop"
          />
          <input
            type="button"
            :value="$anm22.strLang(lang, 'Delete', 'Annulla')"
            @click="deleteDrop"
            class="com-anm22-button-red"
            style="margin-left: 10px"
          />
        </div>
      </div>
    </wg-modal>
    <div class="anm22-calendar-headmenu" style="padding: 13px 8px 13px 8px">
      <div class>
        <b>
          <span
            :class="[
              'anm22-calendar-change-month-button',
              'prev',
              loadEvent ? 'block' : '',
            ]"
            style="left: 4px"
            @click="prevMonth()"
            >&lt;</span
          >
          <span
            :class="[
              'anm22-calendar-change-month-button',
              'succ',
              loadEvent ? 'block' : '',
            ]"
            style="left: 30px"
            @click="nextMonth()"
            >&gt;</span
          >
          <span class="anm22-calendar-change-week-month">{{
            month.format("MMMM YY").toUpperCase()
          }}</span>
        </b>
      </div>
      <img
        :src="$anm22.icons.getWorldIcon('menuAvailability')"
        :title="$anm22.strLang(lang, 'Search', 'Cerca')"
        @click="$emit('searchEvent')"
        class="filter"
        style="right: 45px; cursor: pointer"
      />
      <!-- <div v-if="closeWork==false">
      <span class="anm22-calendar-tutorial-changeWork filter" style="width:200px;height:50px;right:70px;">
        Per cambiare il calendario e passare a quelli aziendali clicca qui.
        <div class="arrowup"></div>
        <div class="close" @click="closeChangeWork()">X</div>
      </span>
      </div>-->
      <span
        style="cursor: pointer; right: 114px"
        @click="newEvent()"
        class="newEventButton"
      >
        <div>
          <span class="wg-xs-none wg-sm- text">{{
            $anm22.strLang(lang, "New Event", "Nuovo Evento")
          }}</span>
          <img :src="$anm22.icons.getWorldIcon('addGreen')" />
        </div>
      </span>
      <img
        @click="changeView()"
        class="changeCalendarViewMode"
        :class="['changeCalendarViewMode', loadEvent ? 'block' : '']"
        :title="$anm22.strLang(lang, 'Change view', 'Cambia visualizzazione')"
        :src="$anm22.icons.getWorldIcon('viewCols')"
        style="opacity: 0.46; cursor: pointer; right: 15px"
      />
      <template v-if="currentW == 'my'">
        <div
          class="my-project-icon work my-events"
          style="cursor: pointer"
          :title="$anm22.strLang(lang, 'My events', 'I miei eventi')"
          @click="$emit('showWorks')"
        >
          {{ user.name.substring(0, 1) }}
        </div>
      </template>
      <template v-else>
        <div class="anm22-calendar-round work">
          <img
            class="work-select"
            style="cursor: pointer"
            :title="workCurrent ? workCurrent.name : undefined"
            :src="
              $anm22.getObjIcon(
                $store.getters['works/get'](currentW),
                'workDefault',
              )
            "
            @click="$emit('showWorks')"
          />
        </div>
      </template>
      <template v-if="box == false">
        <span
          class="anm22-calendar-tutorial-changeWork workBox"
          style="width: 200px; height: 50px; right: 72px"
        >
          {{
            $anm22.strLang(
              lang,
              "To switch the calendar and move to company ones click here.",
              " Per cambiare il calendario e passare a quelli aziendali clicca qui.",
            )
          }}
          <div class="arrowup"></div>
          <div class="close" @click="$emit('close')">X</div>
        </span>
      </template>
    </div>

    <div class="clear-fix"></div>
    <div class="calendar">
      <div class="calendar__header">
        <div
          v-for="(element, index) in calendar.slice(0, 7)"
          :key="'grid-head-' + index"
        >
          {{ element.day.format("ddd").toUpperCase() }}
        </div>
      </div>
      <div class="calendar__week">
        <div
          v-for="(element, index) in calendar"
          :key="index"
          @click="newEvent(element.day)"
          :class="
            element.day.format('MMMM') === month.format('MMMM')
              ? 'calendar__day'
              : 'calendar__month'
          "
          @dragover.prevent
          @drop.prevent="dropEvent(element.day, $event)"
        >
          <div class="display-flex events-container">
            <div
              :class="[
                element.day.format('DD/MM/YYYY') === now.format('DD/MM/YYYY')
                  ? 'today'
                  : '',
              ]"
            >
              {{ element.day.format("D") }}
            </div>
            <div
              v-if="
                currentW == 16 &&
                dailyCounters.find(
                  (obj) => obj.date == element.day.format('DD/MM/YYYY'),
                )
              "
              class="counters"
            >
              <div class="estero">
                {{
                  dailyCounters.find(
                    (obj) => obj.date == element.day.format("DD/MM/YYYY"),
                  ).ESTERO.value
                }}
              </div>
              <div class="riparazioni">
                {{
                  dailyCounters.find(
                    (obj) => obj.date == element.day.format("DD/MM/YYYY"),
                  ).RIPARAZIONI.value
                }}
              </div>
              <div class="garanzia">
                {{
                  dailyCounters.find(
                    (obj) => obj.date == element.day.format("DD/MM/YYYY"),
                  ).GARANZIA.value
                }}
              </div>
            </div>
            <event-bar
              v-for="(event, index) in element.events"
              :key="'event-' + index"
              :eventId="event.idWorldEvent"
              @selectEvent="$emit('selectEvent', $event)"
              :draggable="event.draggable ? true : false"
              @dragstart.native="selectDragEvent(event, $event)"
            ></event-bar>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Spinner from "vue-simple-spinner";
import EventBar from "../components/events/EventBar.vue";

export default {
  props: {
    selectedTimezone: [String],
    now: Object,
    events: Array,
    available: Boolean,
    loadEvent: Boolean,
    currentTime: [Number],
    workAvailable: Boolean,
    box: [Boolean, String],
    currentW: [Number, String],
    getMyEvents: [Function],
    getWorkEvents: [Function],
    loading: [Boolean],
  },
  data() {
    return {
      monthOffset: 0,
      red: "red",
      green: "green",
      dataMeet: "",
      name: "Events",
      dragEvent: null,
      dragOffsetY: 0,
      isDropModalOpen: false,
      dropNewDate: null,
      dropNewTimestamp: null,
    };
  },
  components: {
    EventBar,
    "vue-simple-spinner": Spinner,
  },
  computed: {
    ...mapState({
      windowWidth: (state) => state.windowWidth,
      user: (state) => state.auth.user,
      lang: (state) => state.lang,
    }),
    employments() {
      return this.$store.getters["employments/getAll"];
    },
    workCurrent() {
      return this.$store.getters["works/get"](this.currentW);
    },
    invites() {
      return this.$store.getters["invites/getAll"];
    },
    // work() {
    //   return this.$store.getters["works/getAll"];
    // },
    works() {
      return ["my"].concat(
        this.$store.getters["works/getAll"].map((w) => w.idWorldWork),
      );
    },
    users() {
      return this.$store.getters["users/getAll"];
    },
    month() {
      return this.now.clone().add(this.monthOffset, "months");
    },
    newCurrentData() {
      return this.now.clone().add(this.monthOffset, "months");
    },
    newCurrentTime() {
      return this.newCurrentData.unix();
    },
    calendar() {
      let result = [];
      const startDay = this.month.clone().startOf("month").startOf("week");
      const endDay = this.month.clone().endOf("month").endOf("week");
      let date = startDay.clone().subtract(1, "day");

      while (date.isBefore(endDay, "day")) {
        let day = date.add(1, "day").clone();
        result.push({
          day: day,
          events: this.events
            .sort((a, b) => a.startTimestamp - b.startTimestamp)
            .filter((e) => {
              const startEvent = this.timestampToTimezone(e.startTimestamp);
              const endEvent = this.timestampToTimezone(e.endTimestamp);
              // const startEvent = this.$moment.unix(e.startTimestamp);
              // const endEvent = this.$moment.unix(e.endTimestamp);
              return day.isBetween(startEvent, endEvent - 1, "day", []);
            }),
        });
      }

      return result;
    },
    dailyCounters() {
      return this.$store.getters["dailyCounters/getAllByWork"](this.currentW);
    },
  },
  methods: {
    newEvent(date) {
      if (!date) {
        this.$emit("newEvent", this.$moment());
      } else {
        this.$emit(
          "newEvent",
          date.clone().set({
            h: this.$moment().format("HH"),
            m: this.$moment().format("mm"),
          }),
        );
      }
    },
    timestampToTimezone(ts) {
      return this.$moment.unix(ts).tz(this.selectedTimezone);
    },
    timestampToDate(ts) {
      const moment = this.timestampToTimezone(ts);
      return this.$moment(
        moment.format("YYYY") +
          "-" +
          moment.format("MM") +
          "-" +
          moment.format("DD"),
      );
    },
    // var dateString = date;
    // var m = this.$moment(dateString, "ddd MMM D YYYY HH:mm:ss ZZ");
    // m.set({ h: this.$moment().format("HH"), m: this.$moment().format("mm") });
    // const el = {
    //   creator: this.user.idWorldUser,
    //   startTimestamp: m.unix(),
    //   endTimestamp: m
    //     .clone()
    //     .add(1, "hour")
    //     .unix()
    // };
    // return el;
    // },
    prevMonth() {
      this.monthOffset--;
      this.$parent.currentTime = this.newCurrentTime;
      this.$parent.loadEvent = true;
      this.currentW === "my" ? this.getMyEvents() : this.getWorkEvents();
    },
    nextMonth() {
      this.monthOffset++;
      this.$parent.currentTime = this.newCurrentTime;
      this.$parent.loadEvent = true;
      this.currentW === "my" ? this.getMyEvents() : this.getWorkEvents();
    },
    changeView() {
      this.$parent.currentTime = this.$moment().unix();
      this.$parent.loadEvent = true;
      this.currentW === "my" ? this.getMyEvents() : this.getWorkEvents();
      this.$emit("changeView", "WeeklyView");
    },
    selectDragEvent(event, e) {
      this.dragEvent = event;
      const rect = e.currentTarget.getBoundingClientRect();
      this.dragOffsetY = e.clientY - rect.top;
      e.dataTransfer.effectAllowed = "move";
    },
    dropEvent(date, e) {
      // Detect day hour
      const rect = e.currentTarget.getBoundingClientRect();
      const dropY = e.clientY - rect.top - this.dragOffsetY;
      let dropTime = 0;

      const timestamp = date.unix() + dropTime * 3600;

      this.dropNewDate = date;
      this.dropNewTimestamp = timestamp;
      this.isDropModalOpen = true;
    },
    confirmDrop() {
      /*
      const timestamp = this.dropNewTimestamp;
      const eventLength = this.dragEvent.endTimestamp - this.dragEvent.startTimestamp;
      const endTimestamp = timestamp + eventLength;
      this.dragEvent.startTimestamp = timestamp;
      this.dragEvent.endTimestamp = endTimestamp;
      */

      this.saveProjectDeadline(
        this.dragEvent.projectRef,
        this.dragEvent.work,
        this.dropNewDate,
      );
    },
    deleteDrop() {
      this.dropNewDate = null;
      this.dropNewTimestamp = null;
      this.isDropModalOpen = false;
    },
    saveProjectDeadline(projectId, work, deadline) {
      const deadlineTimestamp = deadline.utc().startOf("day").unix() + 86400;
      this.$http
        .post(
          "/../../../tasks/spa/controller/project/edit/",
          {
            project: {
              idWorldProject: projectId,
              endDate: deadlineTimestamp,
            },
            work,
          },
          {
            withCredentials: true,
          },
        )
        .then((response) => {
          //Salvo con localForage
          this.$store
            .dispatch("projects/update", {
              vlf: this.$vlf("projects"),
              objs: response.data.projects,
            })
            .then(() => {
              // Update event preview
              const timestamp = deadline.utc().startOf("day").unix() + 86400;
              const eventLength =
                this.dragEvent.endTimestamp - this.dragEvent.startTimestamp;
              const endTimestamp = timestamp + eventLength;
              this.dragEvent.startTimestamp = timestamp;
              this.dragEvent.endTimestamp = endTimestamp;

              // Reset modal
              this.dropNewDate = null;
              this.dropNewTimestamp = null;
              this.isDropModalOpen = false;

              //Per sicurezza aggiorno la copia locale del progetto con quanto salvato nello stato
              this.project = {
                ...this.$store.getters["projects/get"](projectId),
              };
              this.$anm22.eventBus.$emit("world-headbar-show-message", {
                text: this.$anm22.strLang(
                  this.lang,
                  "Project update successful",
                  "Salvataggio progetto avvenuto con successo",
                ),
                type: "suggestion",
              });
            })
            .catch((error) => console.log(error));
        })
        .catch((error) => {
          this.$anm22.eventBus.$emit("world-headbar-show-message", {
            text: this.$anm22.strLang(
              this.lang,
              "Project update error",
              "Errore salvataggio progetto",
            ),
            type: "error",
          });
        });
    },
  },
  created() {},
};
</script>
<style lang="scss" scoped>
.month-text {
  font-size: 2.9em;
  color: #a8b2b9;
}
.anm22-calendar-headmenu-custom {
  padding: 13px 8px 13px 0px;
  position: relative;
  height: 46px;
  box-sizing: border-box;
  background-color: #fafafa;
  line-height: 1;
  font-size: 18px;
}

.anm22-calendar-change-month-button {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  width: 24px;
  height: 24px;
  margin: 0;
  border-radius: 15px;
  text-align: center;
  cursor: pointer;
  display: inline-block;
  position: absolute;
  top: 11px;
  line-height: 1;
  padding: 2px 0 0 0;
}
.contMenu {
  padding: 0;
  list-style: none;
  display: flex;
  align-items: center;
  justify-content: center;

  float: left;
  vertical-align: middle;
  position: relative;
}

.toolbar {
  display: flex;
  align-items: center;
  margin-bottom: 24px;
}

.toggle {
  display: grid;
  grid-template-columns: 1fr 1fr;

  text-align: center;
  font-size: 0.9em;
}
.work-select {
  position: absolute;
  top: 6px;
  right: 77px;
  width: 32px;
  height: 32px;
  border-radius: 16px;
}
.my-events {
  position: absolute;
  top: 6px;
  right: 77px;
}
@media screen and (max-width: 779px) {
  .anm22-calendar-change-week-month {
    margin-left: 50px;
  }
}
.block {
  pointer-events: none;
}
@media screen and (max-height: 300px) {
  .anm22-calendar-headmenu {
    height: 46px;
  }
  .anm22-calendar-headmenu .newEventButton {
    top: 13px;
  }

  .anm22-calendar-headmenu .filter {
    top: 8px;
  }
  .anm22-calendar-headmenu .changeCalendarViewMode {
    top: 11px;
  }
}
.close {
  color: #aaa;
  float: right;
  font-size: 14px;
  margin-top: -27px;
  margin-right: -5px;
  font-weight: bold;
  cursor: pointer;
}
.toggle__option {
  padding: 16px;
  border: 1px solid #e1e1e1;
  border-radius: 8px;
  text-transform: capitalize;
  cursor: pointer;
}

.toggle__option:first-child {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.toggle__option:last-child {
  border-left: 0;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.toggle__option--selected {
  border-color: white;
  background-color: white;
  color: var(--red);
  font-weight: 500;
  box-shadow: 1px 2px 30px -5px var(--red);
}
.events {
  padding: 1px;
  margin: 2px;
  width: 100%;
  background-color: #ffffff;
  border-radius: 5px;
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  height: 23px;
}
.eventimg {
  margin: 2px 5px 0 0;
  width: 18px;
  height: 18px;
  float: right;
}
@media (max-width: 290px) {
  .newEventButton {
    display: none;
  }
}
@media (max-width: 767px) {
  .events {
    height: 19px;
  }
  .events:hover {
    height: 40px;
  }
}
.events_lock {
  padding: 1px;
  margin: 2px;
  width: 100%;
  background-color: #7f8c8d;
  border-radius: 5px;
  opacity: 0.9;
}

.events:hover {
  background-color: #ebebeb;
  border-radius: 5px;
  border-color: #a8b2b9;
  color: #000000;
  height: 100%;
}

.monthBar {
  width: 100%;
  text-align: center;
  display: flex;
  margin-top: 10px;
  display: inline-block;
}

.day-of-week {
  width: calc(100% / 7);
  justify-content: center;
}

.wg-row {
  height: 50px;
  text-align: center;
}

.centered {
  position: relative;
  align-content: center;
  margin-top: 15px;
}
.day-block {
  height: 100%;
  flex-direction: column;
  flex-wrap: nowrap;
  padding: 0 2px;
  cursor: pointer;
  &.other-month {
    opacity: 0.4;
  }
  &:hover {
    background-color: #eee;
  }
}
.arrowup {
  width: 0px;
  height: 0px;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 10px solid #fff;
  position: absolute;
  right: 8px;
  top: -10px;
}

.day-projects-div {
  height: 100%;
  & div {
    height: calc(100% / 6);
    padding: 1px 2px;
  }
}
.my-project-icon {
  display: inline-block;
  background-color: #00af87;
  color: #fff;
  padding-top: 7px;
  line-height: 1.1;
  box-sizing: border-box;
  text-align: center;
  overflow: hidden;
  border-radius: 30px;
  vertical-align: middle;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.work {
  width: 32px;
  height: 32px;
  border-radius: 16px;
}
.newEventButton-custom {
  position: absolute;
  top: 13px;
  right: 120px;
  line-height: 1;
  height: 16px;
}

.project-label {
  flex-wrap: nowrap;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  border-radius: 2px;
  background-color: #fff;
}

.current_momth {
  font-family: Montserrat;
  font-weight: 100;
  color: #a8b2b9;
}

.toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}

.calendar__week,
.calendar__header {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
}
.calendar__week {
  grid-auto-rows: calc((100vh - 156px) / 5);
  text-align: right;
  grid-auto-columns: 200px;
}

.calendar__header {
  grid-auto-rows: 50px;
  align-items: center;
  text-align: center;
}

.calendar__day {
  padding: 5px;
  cursor: pointer;
  overflow-y: auto;
}
.calendar__month {
  padding: 5px;
  cursor: pointer;
  overflow-y: auto;
  overflow-x: hidden;
  background-color: #fdfdfd;
  opacity: 0.6;
  border-right: 1px solid #dfe6e9;
  border-top: 1px solid #dfe6e9;
  border-left: 1px solid #dfe6e9;
  border-bottom: 1px solid #dfe6e9;
  //border-right: 0;
  user-select: none;
}

.events-container {
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: flex-end;
  position: relative;
}

.copyright {
  font-size: 0.7rem;
  font-weight: 400;
}

.calendar {
  background-color: #ffffff;
  //border: 1px solid #e1e1e1;
}

.workBox {
  position: absolute;
  top: 108px;
  right: 20px;
  padding: 4px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 40px;
  height: 40px;
  border-radius: 3px;
  background-color: white;
  -webkit-box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.26);
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.26);
  color: black;
  line-height: 1;
  font-size: 14px;
  text-align: left;
  font-weight: 400;
}
.arrowup {
  width: 0px;
  height: 0px;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 10px solid #fff;
  position: absolute;
  right: 8px;
  top: -10px;
}

.calendar__header > div {
  text-transform: uppercase;
  font-size: 0.8em;
  font-weight: bold;
}

.calendar__day {
  border-right: 1px solid #e1e1e1;
  border-top: 1px solid #e1e1e1;
  overflow-x: hidden;
}

.calendar__day:last-child {
  border-right: 0;
}
/* width */
/* width */
::-webkit-scrollbar {
  width: 4px;
  border-radius: 3px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #ffffffa9;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.today {
  color: white;
  background-color: #f00;
  height: 17px;
  width: 17px;
  border-radius: 50%;
  display: inline-block;
  padding-right: 4px;
  padding-top: 1px;
}

.counters {
  position: absolute;
  top: 0;
  left: 0;

  div {
    display: inline-block;
    vertical-align: middle;
    font-size: 14px;
    text-align: left;
    margin-right: 2px;

    &.estero {
      color: #ff0000;
    }
    &.riparazioni {
      color: #ffca28;
    }
    &.garanzia {
      color: #f400a1;
    }
  }
}
</style>
